import gql from "graphql-tag";

export const GET_VIDEO_CALLS_QUERY = gql`
  query($getAvailableVideoCallsInput: GetAvailableVideoCallsInput!) {
    getAvailableVideoCalls(getAvailableVideoCallsInput: $getAvailableVideoCallsInput) {
      ... on GetAvailableVideoCallsErrorOutput {
        errorReason
      }
      ... on GetAvailableVideoCallsOutput {
        videoCalls {
          created
          creatorFullName
          creatorUserId
          participantEmails
          roomName
      }
    }
  }
}
`;